import { Avatar, type AvatarProps } from "@mui/material";

interface UserAvatarProps extends Omit<AvatarProps, "src"> {
  name?: string | null;
  picture?: string | null;
  size?: number;
}

function initialsOf(name?: string | null): string {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/).slice(0, 2);
  return parts.map((p) => p[0]?.toUpperCase() ?? "").join("") || "?";
}

/**
 * Renders the user's Google profile picture when available, otherwise a
 * monogram of their initials over a neutral background. Never an emoji.
 */
export function UserAvatar({
  name,
  picture,
  size = 32,
  sx,
  ...rest
}: UserAvatarProps) {
  return (
    <Avatar
      src={picture ?? undefined}
      alt={name ?? "User"}
      sx={{
        width: size,
        height: size,
        fontSize: size * 0.4,
        bgcolor: "surface.raisedHover",
        color: "text.primary",
        fontWeight: 600,
        border: "1px solid",
        borderColor: "border.default",
        ...sx,
      }}
      {...rest}
    >
      {initialsOf(name)}
    </Avatar>
  );
}
